import { Suspense } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useRouteBoundary } from '@acp/feature/auth';
import { AppLoader } from '../components/app-loader';

/**
 * Like RouteBoundary (auth-gated, redirects to login on failure), but skips
 * AppLayout entirely — no navbar/footer. For standalone pages meant to be
 * opened directly (e.g. a redirect tab from a notification click).
 */
export function NoNavRouteBoundary() {
    const navigate = useNavigate();
    const location = useLocation();

    const [isLoading] = useRouteBoundary({
        agencyId: null,
        onFailure: () => navigate(`/auth/login?redirect=${encodeURIComponent(`${location.pathname}${location.search}`)}`, {
            replace: true,
        }),
    });

    if (isLoading) {
        return <AppLoader />;
    }

    return (
        <Suspense fallback={<AppLoader />}>
            <Outlet />
        </Suspense>
    );
}
